<section class="position-relative py-5">
    <div class="container-fluid w-limit">
        <div class="row justify-content-center text-center align-items-center mb-5">
            <div class="col-12">
                <div class="mb-3">
                    <app-icon name="check-circle" [size]="64" [strokeWidth]="2" color="#198754"></app-icon>
                </div>
                <h1 class="fs-4 text-success mt-2 fw-bold">¡Gracias por tu compra!</h1>
                <p class="text-body-tertiary mb-4 fs-6 fw-semibold small mx-auto" style="max-width: 500px;">
                    Tu póliza ha sido emitida exitosamente. Hemos enviado los detalles a tu correo electrónico.
                </p>
                <div *ngIf="currentQuote?.policyNumber"
                    class="alert alert-success d-inline-block px-4 py-2 rounded-pill">
                    <strong>Póliza No. {{ currentQuote?.policyNumber }}</strong>
                </div>
                <!-- Transaction Info -->
                <div class="mt-2 text-muted small"
                    *ngIf="currentQuote?.transactionId || currentQuote?.authorizationCode">
                    <span *ngIf="currentQuote?.transactionId" class="me-3">Transacción: <strong>{{
                            currentQuote?.transactionId }}</strong></span>
                    <span *ngIf="currentQuote?.authorizationCode">Autorización: <strong>{{
                            currentQuote?.authorizationCode }}</strong></span>
                </div>
            </div>
        </div>

        <div class="row g-3 g-md-4 justify-content-center">
            <!-- List of Insurance Types -->
            <div class="col-12 col-lg-8">
                <h3 class="fs-6 fw-semibold text-uppercase mb-3 text-secondary">Tus pólizas adquiridas</h3>
                <div class="d-flex flex-column gap-3">
                    @for (detail of details; track detail.id || $index) {
                    <div class="card card-policy-summary border rounded-3 border-0 shadow-sm">
                        <div class="card-body p-3 d-flex align-items-center justify-content-between">
                            <div class="d-flex gap-3 align-items-center">
                                <span class="icon bg-success-subtle rounded-circle p-2">
                                    <app-icon name="shield-check" [size]="24" [strokeWidth]="2"
                                        color="#198754"></app-icon>
                                </span>
                                <div class="d-flex flex-column">
                                    <span class="fw-bold text-dark">{{ detail.insuranceType?.name || 'Seguro' }}</span>
                                    <small class="text-success fw-bold" *ngIf="detail.policyNumber">Póliza No. {{
                                        detail.policyNumber }}</small>
                                    <small class="text-muted">{{ detailPlanName(detail.id) }}</small>
                                    @if (detail.beneficiaries?.length) {
                                    <small class="text-muted mt-1">
                                        <span class="fw-semibold">Beneficiarios:</span>
                                        @for (b of detail.beneficiaries; track b.id || $index; let last = $last) {
                                        {{ b.name }} {{ b.lastName }} ({{ relationshipLabel(b.relationship) }}, {{
                                        b.percentage }}%){{ last ? '' : '; ' }}
                                        }
                                    </small>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                    }
                </div>
            </div>

            <!-- Summary Card -->
            <div class="col-12 col-lg-4">
                <div class="card border-0 shadow rounded-3 summary-card w-100">
                    <div class="card-body">
                        <h3 class="fs-6 mb-3 fw-semibold text-uppercase d-flex gap-3 align-items-center text-secondary">
                            <app-icon name="receipt" [size]="24" [strokeWidth]="2"></app-icon>
                            <small>Resumen del pago</small>
                        </h3>
                        <div class="d-flex flex-column small gap-2 resumen-items">
                            <div class="d-flex justify-content-between py-2 border-bottom">
                                <span class="text-muted">Subtotal:</span>
                                <strong class="text-dark">{{ quoteCurrency }} {{ (summary?.totalNetPremium ?? 0) |
                                    number:'1.2-2' }}</strong>
                            </div>
                            <div class="d-flex justify-content-between py-2 border-bottom">
                                <span class="text-muted">ISC:</span>
                                <strong class="text-dark">{{ quoteCurrency }} {{ (summary?.totalTaxes ?? 0) |
                                    number:'1.2-2' }}</strong>
                            </div>
                            <div class="d-flex justify-content-between py-3">
                                <span class="fw-bold fs-6">TOTAL PAGADO:</span>
                                <strong class="fw-bold fs-6 text-success">{{ quoteCurrency }} {{
                                    (summary?.totalGrossPremium ?? 0) | number:'1.2-2' }}</strong>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row justify-content-center mt-5">
            <div class="col-auto">
                <button class="btn btn-primary rounded-pill px-5 py-2 fw-semibold shadow-sm" (click)="onGoHome()">
                    Volver al Inicio
                </button>
            </div>
        </div>
    </div>
</section>